import script from "./user-detail-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-detail-panel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__